<script lang="ts" setup>
import type { PlanktonPredefinedRight } from "~~/server/plankton";
import { RenderOnlySlot } from "./RenderOnlySlot";

const props = defineProps<{
  right: PlanktonPredefinedRight;
}>();

const { user } = useUserSession();

const userHasRight = computed(() => {
  return hasRight(user.value, props.right);
});
</script>

<template>
  <RenderOnlySlot v-if="userHasRight">
    <slot />
  </RenderOnlySlot>
</template>
